











































import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class CardIcon extends Vue {
    @Prop(Boolean) bad;
    get color() {
        return this.$vuetify.theme.themes.light.primary;
    }
    get secondary() {
        return this.$vuetify.theme.themes.light.secondary;
    }
}
